<template>
  <!--动产抵押-->
  <TableView
    :columns="columns"
    :data="data"
    :pagination="false"
    :loading="loading"
    :bordered="bordered"
    :scroll="scroll"
    :rowKey="rowKey"
  ></TableView>
</template>
<script>
import { TableView } from '@/lxfintech-fe-components'
export default {
  props: ['data'],
  components: { TableView },
  data() {
    return {
      rowKey: 'id',
      scroll: { x: 1300 },
      columns: [
        {
          title: '序号',
          width: 100,
          dataIndex: 'order',
          key: 'order',
          fixed: 'left',
          customRender: (text, record, index) => {
            return index + 1
          },
        },
        {
          title: '登记编号',
          dataIndex: 'registrationNum',
          key: 'registrationNum',
        },
        {
          title: '登记日期',
          dataIndex: 'registrationDate',
          key: 'registrationDate',
        },
        {
          title: '登记机关',
          dataIndex: 'registrationInstitution',
          key: 'registrationInstitution',
        },
        {
          title: '被担保债权数额',
          dataIndex: 'amount',
          key: 'amount',
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
        },
      ],
      loading: false,
      bordered: true,
    }
  },
  methods: {},
}
</script>
